import { visserApi } from './visserApi';
const getAllJobCategories = async () => {
    return await visserApi.get('Job/GetAllJobCategories');
};
const createJobCategory = async (createdJobCategory) => {
    return await visserApi.post('Job/CreateJobCategory', createdJobCategory);
};
const updateJobCategory = async (updateEmployeeHourType) => {
    return await visserApi.put('Job/UpdateJobCategory', updateEmployeeHourType);
};
const getJobCategoryById = async (id) => {
    return await visserApi.get(`Job/GetJobCategoryById/${id}`);
};
const JobCategoryApi = {
    getAllJobCategories,
    createJobCategory,
    updateJobCategory,
    getJobCategoryById
};
export default JobCategoryApi;
